import { render, staticRenderFns } from "./SkinDiagnosticGuide.vue?vue&type=template&id=6a0cd0ed&scoped=true"
import script from "./SkinDiagnosticGuide.vue?vue&type=script&lang=js"
export * from "./SkinDiagnosticGuide.vue?vue&type=script&lang=js"
import style0 from "./SkinDiagnosticGuide.vue?vue&type=style&index=0&id=6a0cd0ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0cd0ed",
  null
  
)

export default component.exports